import * as globalAPI from "../../../api/global";
import * as listingApi from '../../../api/listing';
import ListingNodeComponent
  from '../../../components/04_templates/ListingPage/ListingPage';
import {useListingsSolrSearch} from "../../../utils/hooks";
// import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";

export async function getStaticProps(context) {
  const {params} = context;

  let initialProps = {
    statusCode: 200,
  };
  let data, node_data;

  try {
    // Node data about currently opened node.
    data = await globalAPI.getPageInfo(`/buy/${params.list_id}/${params.listing}`);

    // Check for any redirects:
    const regex1 = new RegExp('eatonrealty\.com|\.lndo\.site', 'ig');
    if (data?.page?.redirect && !regex1.test(data.page.redirect?.[0]?.to) && data?.page?.redirect?.length > 0) {
      let dest = data.page?.redirect[0]?.to;
      return {
        redirect: {
          destination: dest,
          statusCode: parseInt(data.page?.redirect[0]?.status),
        },
      }
    }

    if (data?.page?.entity) {
      node_data = await listingApi.getFullListingInfo(data.page.entity.uuid);
      if (node_data) {
        initialProps = {...initialProps, ...node_data};
      }
    }

    // Merge initially defined props with response from the backend.
    initialProps = {...initialProps, ...data};
    if (!data) {
      return {
        notFound: true,
      }
    }
  }
  catch (e) {
    console.warn('RETS listing retrieval error:', e);
    // Pass status code as internal properly. It is being checked inside of
    // render() method of _app.js.
    initialProps.statusCode = 500;

    // In case of Server Side Rendering, we want the server to throw the
    // correct error code.
    // if (res) {
    //   res.statusCode = 500;
    // }
  }

  return {
    props: {
      ...initialProps,
    }, // will be passed to the page component as props
    revalidate: 900,
    // notFound: true, // https://github.com/vercel/next.js/discussions/11862,
    // https://stackoverflow.com/questions/67946219/throw-new-errorfailed-to-load-static-props-when-setting-fallback-true-i/67946220#67946220
  }
}

export async function getStaticPaths() {
  // Get the paths we want to pre-render based on pages
  const paths = [];
  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return {paths, fallback: true}
}

function ListingSalePage(props) {
  let node_data, node, meta, boundaries;

  if (props) {
    node = props?.page?.entity || null;
    meta = props?.metatags?.tags || [];

    if (node && props.page_data) {
      node_data = props.page_data;
      if (node.bundle == 'listing' && node_data?.coord?.value) {
        const fetchBoundary = {
          solrBoundaryPages: true,
          // index_id: 'boundary_terms',
          // content_type: 'boundary_page',
          rent_sale: 'Buy',
          geo_boundary: node_data.coord.value,
          city: (Array.isArray(node_data.cityTerm)) ? node_data.cityTerm.map(el => el.internalId) : [node_data.cityTerm?.internalId],
          // sort: [{dir: 'DESC', field: 'ds_modified'}],
          // page: 0,
        };
        let schools = [];
        if (node_data.elemSchool) {
          schools.push(node_data.elemSchool.internalId);
        }
        if (node_data.midSchool) {
          schools.push(node_data.midSchool.internalId);
        }
        if (node_data.highSchool) {
          schools.push(node_data.highSchool.internalId);
        }
        if (schools.length > 0) {
          fetchBoundary.schools = schools;
        }
        boundaries = useListingsSolrSearch(fetchBoundary);
      }
    }
  }

  return (

    <div style={{minHeight: 1000}}>
      {node && node_data &&
      <div className={`node node-type-${node?.bundle} node-${node?.id}`}>
        <ListingNodeComponent node={node_data}
                              boundary={boundaries?.data?.page_data}
                              metatags={meta}/>
      </div>
      }
    </div>

  );
}

export default ListingSalePage;
